import axios from "axios";
import {Dispatch} from "redux";
import {updateSmartBetActionTypes, updateSmartBetAction} from "../../../types/composer/SmartBet/updateSmartBet";

export const updateSmartBetData = (id:string, updatedSmartBetData: object): any => {
    return async (dispatch: Dispatch<updateSmartBetAction>) => {
        try {
            dispatch({type: updateSmartBetActionTypes.FETCH_UPDATE_SMART_BET_DATA});
            const response = await axios({
                method: 'put',
                url: `/api/composer/smartbets/${id}`,
                data: updatedSmartBetData,
                withCredentials: false,
            });

            dispatch({type: updateSmartBetActionTypes.FETCH_UPDATE_SMART_BET_DATA_SUCCESS, payload: response.data})
        } catch (error: any) {
            let errorMessage = 'Something went wrong. Please try again.';

            if (axios.isAxiosError(error) && error.response && error.response.data && error.response.data.detail) {
                errorMessage = error.response.data.detail.map((err: any) => err.msg).join(`/n`);
            } else if (axios.isAxiosError(error) && error.response && error.response.data && error.response.data.message) {
                errorMessage = error.response.data.message;
            } else if (error.message) {
                errorMessage = error.message;
            }
            dispatch({
                type: updateSmartBetActionTypes.FETCH_UPDATE_SMART_BET_DATA_ERROR,
                payload: errorMessage
            });
        }
    }
}

export const clearSmarbetUpdateDataState = () => {

    return (dispatch: Dispatch<updateSmartBetAction>) => {
        dispatch({
            type: updateSmartBetActionTypes.CLEAR_SMART_BET_STATE,
            payload: {}
        });
    };
};